var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isNotLinkToMp)?_c('hm-header'):_vm._e(),_c('router-view'),(_vm.isNotLinkToMp)?_c('hm-footer'):_vm._e(),(_vm.isNotLinkToMp)?_c('hm-back-top'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }